export var skeletonLineStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return {
      display: 'block',
      width: p.width,
      height: p.height,
      backgroundColor: v.lineBackground,
      margin: v.lineMargin
    };
  }
};
//# sourceMappingURL=skeletonLineStyles.js.map
